import Select from '../helpers/Select';

$(document).ready(function () {
    $('form').each(function () {
        new Select($(this));
    });
});